import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter, startWith } from 'rxjs';
import { HeaderComponent } from './shared/components/header/header.component';
import { FooterComponent } from './shared/components/footer/footer.component';
import { BackToTopComponent } from './shared/components/back-to-top/back-to-top.component';
import { AnalyticsService } from './shared/services/analytics.service';
import { SeoService } from './shared/services/seo.service';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, HeaderComponent, FooterComponent, BackToTopComponent],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  private readonly seo = inject(SeoService);
  private readonly analytics = inject(AnalyticsService);
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);

  ngOnInit() {
    this.analytics.init();
    this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        startWith(null)
      )
      .subscribe(() => {
        const activeRoute = this.getLeafRoute(this.route);
        const path = this.router.url.split('?')[0] || '/';
        const pageTitle = activeRoute.snapshot.data['title'] || 'MemberTrace';
        const pageDescription = activeRoute.snapshot.data['description']
          || 'MemberTrace helps professional communities manage memberships, events, directories, and growth in one place.';

        this.seo.apply({
          title: pageTitle,
          description: pageDescription,
          path,
          ogType: 'website',
          robots: activeRoute.snapshot.data['robots']
        });
        this.analytics.trackPageView(path, pageTitle);
      });
  }

  private getLeafRoute(route: ActivatedRoute): ActivatedRoute {
    let activeRoute = route;

    while (activeRoute.firstChild) {
      activeRoute = activeRoute.firstChild;
    }

    return activeRoute;
  }
}
